// extracted by mini-css-extract-plugin
module.exports =  {"PartNotFound":"PartNotFound__ArTz0"};